<template>
  <div class="form-item-webform-actions">
    <button :id="element.metadata?.key" :name="element.metadata?.key" type="submit" class="form-item-webform-actions__button">
      {{ element.submitLabel }}
    </button>
  </div>
</template>
<script setup lang="ts">
import { type WebformElementWebformActionsFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

defineProps<{
  element: WebformElementWebformActionsFragment,
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-webform-actions {
  &__button {
    @include tools.form-field-button;
  }
}
</style>
